import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Heading,
  Image,
  Link,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import { BsGithub, BsLink45Deg } from "react-icons/bs";
import styles from "./Css/SubProject.module.css";
import projectData from "../projectData.json";


export default function SubProject() {
  return (
    <Box maxW="1348px" m="auto" mt="50px" className={styles.SubProject} color="black"

    >
      <SimpleGrid
        m="auto"
        maxW="1048px"
        columns={{ base: 1, sm: 1, md: 2 }}
        spacing="60px"


      >
        {projectData.map((ele) => (
          <Box
            height="auto"
            ele={ele.id + Date.now()}
            bg="#1e2534"
            color='whiteAlpha.900'
          // data-aos="zoom"
          // data-aos-easing="ease-in-out"
          >
            <Box p="15px" m="auto">
              <Image
                m="auto"
                w="500px"
                h="300px"
                data-aos="flip-down"
                data-aos-easing="ease-in-out"
                borderRadius="20px"
                src={  ele.coverImage}
              />
            </Box>

            <Box p="15px" m="auto" mt="">
              <Box className={styles.pipe1}>
                <button className={styles.pipe}>{ele.status}</button>
                <button className={styles.pipe}>{ele.type}</button>
              </Box>

              <SimpleGrid
                className={styles.TechStack}
                columns={{ base: 4, sm: 5, md: 6 }}
                spacing="10px"
              >
                {ele.techStack.map((tech) => (
                  <Box
                    bg="#2B6CB0"
                    height="30px"
                    key={tech + Date.now() + Date()}
                  >
                    {tech}
                  </Box>
                ))}
              </SimpleGrid>

              <Box className={styles.TitleDes}>
                <Heading as="h1" mt="0px">
                  {ele.title}
                </Heading>
                <Text as="p" mt="5px">
                  {ele.description}
                </Text>
              </Box>

              <AvatarGroup
                size="md"
                max={ele.teamMembers.length}
                className={styles.AvatarProfile}
                mt="10px"
              >
                {ele.teamMembers.map((team) => (
                  <Avatar name={team.avatarName} src={team.avatar} />
                ))}
              </AvatarGroup>

              <Box className={styles.githubButton} mb="20px" mt="20px">
                <Box>
                  <Link href={ele.githubLink} target="_blank">
                    <Button colorScheme="teal">
                      Github{" "}
                      <span>
                        {" "}
                        <BsGithub />
                      </span>{" "}
                    </Button>
                  </Link>
                </Box>

                <Box>
                  <Link href={ele.deployLink} target="_blank">
                    <Button colorScheme="teal">
                      Deployment{" "}
                      <span>
                        <BsLink45Deg />
                      </span>{" "}
                    </Button>
                  </Link>
                </Box>
              </Box>
            </Box>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  );
}
